import { render, staticRenderFns } from "./SelectableZones.vue?vue&type=template&id=b16cd6d8&"
import script from "./SelectableZones.vue?vue&type=script&lang=ts&"
export * from "./SelectableZones.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports